import { fonts } from '@/theme/fonts';
import styled from 'styled-components';

interface CommonTitleProps {
  imgUrl: string;
  title: string;
  disabled?: boolean;
  color?: string;
}

const CommonTitle = ({
  imgUrl,
  title,
  disabled = false,
  color,
}: CommonTitleProps) => {
  return (
    <Container data-disabled={disabled} $color={color}>
      <TitleWrap>
        <Img src={imgUrl} alt={`${title}-img`} />
        <div>{title}</div>
      </TitleWrap>
    </Container>
  );
};

export default CommonTitle;

interface ContainerProps {
  $color?: string;
}
const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  gap: 25px;
  color: ${({ $color }) => ($color ? $color : '#6996f8')};
  &[data-disabled='true'] {
    color: #c6c2c2;
  }
`;

const TitleWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  font-weight: ${fonts.weight.bold};
  font-size: 30px;
  line-height: 140%;
  flex-shrink: 0;
`;

const Img = styled.img`
  width: 40px;
  height: 40px;
`;

const CountWrap = styled.div`
  display: flex;
  align-items: end;
  gap: 4px;
`;

const Count = styled.div`
  font-weight: ${fonts.weight.bold};
  font-size: 40px;
  line-height: 140%;
`;

const CountName = styled.div`
  font-weight: ${fonts.weight.light};
  font-size: 15px;
  line-height: 140%;
  padding-bottom: 8px;
`;
